// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3TKT7","info":"UpdateTermsInfo_info__1zhjC"};